var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{on:{"click":_vm.printDocument}},[_vm._v(_vm._s(_vm.$t('pages.handover.print')))])])}
var staticRenderFns = []

export { render, staticRenderFns }